(function(window, document) {
  'use strict';

  // jQuery and Slick normally load before this file (all deferred, in order),
  // but if a CDN is slow or the order changes we wait for them instead of
  // giving up, which used to leave arrows, keyboard control and zoom unset.
  var $ = window.jQuery;

  var gallerySelector = '.js-section__product-single .product-single__photos';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getSlides(slider) {
    return Array.prototype.filter.call(
      slider.querySelectorAll('.product-single__photo__item'),
      function(slide) {
        return !slide.closest('.slick-cloned');
      }
    );
  }

  function getCurrentIndex($slider) {
    var current = parseInt($slider.slick('slickCurrentSlide'), 10);
    return isNaN(current) ? 0 : current;
  }

  function goTo($slider, index) {
    var slides = getSlides($slider[0]);
    var nextIndex = Math.max(0, Math.min(index, slides.length - 1));

    if (slides.length && nextIndex !== getCurrentIndex($slider)) {
      $slider.slick('slickGoTo', nextIndex);
    }
  }

  function replaceMainArrows(gallery, $slider) {
    var arrows = gallery.querySelectorAll('.product-single__photo__nav__item');

    Array.prototype.forEach.call(arrows, function(arrow) {
      var isPrevious = arrow.classList.contains('product-single__photo__nav__item--prev');
      var button = arrow;

      if (arrow.tagName.toLowerCase() !== 'button') {
        button = document.createElement('button');
        button.type = 'button';
        button.className = arrow.className;
        button.innerHTML = arrow.innerHTML;
        arrow.parentNode.replaceChild(button, arrow);
        button.setAttribute('aria-label', isPrevious ? 'Previous product image' : 'Next product image');
        button.addEventListener('click', function(event) {
          event.preventDefault();
          if (button.getAttribute('aria-disabled') === 'true') return;
          $slider.slick(isPrevious ? 'slickPrev' : 'slickNext');
        });
      } else {
        button.setAttribute('aria-label', isPrevious ? 'Previous product image' : 'Next product image');
      }
    });
  }

  function promoteCustomThumbnails(gallery, $slider) {
    var items = gallery.querySelectorAll('.custom-thumbnail-item');

    Array.prototype.forEach.call(items, function(item, itemIndex) {
      var button = item;

      if (item.tagName.toLowerCase() !== 'button') {
        button = document.createElement('button');
        button.type = 'button';
        button.className = item.className;
        button.innerHTML = item.innerHTML;
        button.setAttribute('data-media-id', item.getAttribute('data-media-id') || '');
        button.setAttribute('data-index', item.getAttribute('data-index') || itemIndex);
        item.parentNode.replaceChild(button, item);
      }

      var image = button.querySelector('img');
      var label = image && image.getAttribute('alt');
      button.setAttribute('aria-label', label || 'Show product image ' + (itemIndex + 1));
      button.addEventListener('click', function(event) {
        event.preventDefault();
        goTo($slider, parseInt(button.getAttribute('data-index'), 10));
      });
      button.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          goTo($slider, parseInt(button.getAttribute('data-index'), 10));
        }
      });
    });
  }

  function hydrateCustomThumbnails(gallery) {
    var items = gallery.querySelectorAll('.custom-thumbnail-item');

    Array.prototype.forEach.call(items, function(item) {
      var mediaId = item.getAttribute('data-media-id');
      var source = Array.prototype.find.call(
        gallery.querySelectorAll('.product-single__photo-thumbs__img'),
        function(image) { return image.getAttribute('data-media-id') === mediaId; }
      );
      var target = item.querySelector('img');
      var loader = item.querySelector('.custom-thumbnail-loader');

      // Thumbnails from snippets/ol-gallery-thumbs.liquid already carry their
      // real image; only fill in old placeholder shells.
      if (!source || !target || (target.getAttribute('src') || '').indexOf('data:') !== 0) return;

      var sourceUrl = source.getAttribute('data-src') || source.currentSrc || source.getAttribute('src');
      if (!sourceUrl || target.getAttribute('src') === sourceUrl) return;

      target.onload = function() {
        if (loader) loader.remove();
        target.classList.add('loaded');
      };
      target.onerror = function() {
        if (loader) loader.remove();
      };
      target.src = sourceUrl;
    });
  }

  function setupThumbnailStrip(gallery, $slider) {
    var container = gallery.querySelector('.custom-thumbnail-carousel');
    var previous = gallery.querySelector('.custom-thumbnail-prev');
    var next = gallery.querySelector('.custom-thumbnail-next');
    if (!container || !previous || !next) return;

    function items() {
      return Array.prototype.slice.call(container.querySelectorAll('.custom-thumbnail-item'));
    }

    function currentItemIndex() {
      var active = container.querySelector('.custom-thumbnail-item.active');
      return active ? items().indexOf(active) : getCurrentIndex($slider);
    }

    function updateArrowState() {
      var allItems = items();
      var current = currentItemIndex();
      var previousDisabled = current <= 0;
      var nextDisabled = current >= allItems.length - 1;

      previous.classList.toggle('disabled', previousDisabled);
      next.classList.toggle('disabled', nextDisabled);
      previous.setAttribute('aria-disabled', String(previousDisabled));
      next.setAttribute('aria-disabled', String(nextDisabled));
    }

    function selectAdjacent(direction) {
      var allItems = items();
      var targetIndex = currentItemIndex() + direction;
      if (targetIndex < 0 || targetIndex >= allItems.length) return;
      goTo($slider, parseInt(allItems[targetIndex].getAttribute('data-index'), 10));
    }

    previous.setAttribute('type', 'button');
    next.setAttribute('type', 'button');
    previous.setAttribute('aria-label', 'Previous product image');
    next.setAttribute('aria-label', 'Next product image');
    previous.addEventListener('click', function(event) {
      event.preventDefault();
      selectAdjacent(-1);
    });
    next.addEventListener('click', function(event) {
      event.preventDefault();
      selectAdjacent(1);
    });
    container.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState, { passive: true });

    var startX = 0;
    var startScrollLeft = 0;
    var activePointerId = null;
    var suppressClickUntil = 0;

    container.addEventListener('pointerdown', function(event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      if (event.target.closest && event.target.closest('.custom-thumbnail-item')) return;
      startX = event.clientX;
      startScrollLeft = container.scrollLeft;
      activePointerId = event.pointerId;
      if (container.setPointerCapture) container.setPointerCapture(event.pointerId);
    });
    container.addEventListener('pointermove', function(event) {
      if (activePointerId !== event.pointerId) return;
      var distance = event.clientX - startX;
      if (Math.abs(distance) < 5) return;
      suppressClickUntil = Date.now() + 250;
      container.scrollLeft = startScrollLeft - distance;
      updateArrowState();
    });
    function finishPointer(event) {
      if (activePointerId !== event.pointerId) return;
      if (container.releasePointerCapture && container.hasPointerCapture && container.hasPointerCapture(event.pointerId)) {
        container.releasePointerCapture(event.pointerId);
      }
      activePointerId = null;
    }
    container.addEventListener('pointerup', finishPointer);
    container.addEventListener('pointercancel', finishPointer);
    container.addEventListener('lostpointercapture', finishPointer);
    container.addEventListener('click', function(event) {
      if (Date.now() <= suppressClickUntil) {
        event.preventDefault();
        event.stopPropagation();
        suppressClickUntil = 0;
      }
    }, true);

    gallery.__updateThumbnailArrows = updateArrowState;
    updateArrowState();
  }

  function scrollActiveThumbnail(item) {
    if (!item) return;
    var container = item.closest('.custom-thumbnail-carousel');
    if (!container) return;

    // Centre the thumbnail inside its horizontal strip without allowing the
    // browser to move the document vertically via scrollIntoView().
    var targetLeft = item.offsetLeft - (container.clientWidth - item.offsetWidth) / 2;
    var maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
    container.scrollTo({
      left: Math.max(0, Math.min(targetLeft, maxScrollLeft)),
      behavior: reducedMotion() ? 'auto' : 'smooth'
    });
  }

  function syncGallery(gallery, currentIndex) {
    var slider = gallery.querySelector('.js-product-slider');
    if (!slider) return;
    var slides = getSlides(slider);
    var mediaId = slides[currentIndex] && slides[currentIndex].getAttribute('data-media-id');
    var customItems = gallery.querySelectorAll('.custom-thumbnail-item');
    var originalItems = gallery.querySelectorAll('.product-single__photo-thumbs > div');
    var dots = gallery.querySelectorAll('.js-product-slider-nav-dots .slick-dots li button');

    Array.prototype.forEach.call(customItems, function(item) {
      var active = parseInt(item.getAttribute('data-index'), 10) === currentIndex;
      item.classList.toggle('active', active);
      item.setAttribute('aria-current', active ? 'true' : 'false');
      if (active) scrollActiveThumbnail(item);
    });
    Array.prototype.forEach.call(originalItems, function(item) {
      var image = item.querySelector('img');
      var active = image && image.getAttribute('data-media-id') === mediaId;
      item.classList.toggle('active', active);
      item.setAttribute('aria-current', active ? 'true' : 'false');
    });
    Array.prototype.forEach.call(dots, function(dot, dotIndex) {
      dot.setAttribute('aria-label', 'Show product image ' + (dotIndex + 1));
      dot.setAttribute('aria-current', dotIndex === currentIndex ? 'true' : 'false');
    });

    var previous = gallery.querySelector('.product-single__photo__nav__item--prev');
    var next = gallery.querySelector('.product-single__photo__nav__item--next');
    var previousDisabled = currentIndex <= 0;
    var nextDisabled = currentIndex >= slides.length - 1;
    if (previous) {
      previous.classList.toggle('slick-disabled', previousDisabled);
      previous.setAttribute('aria-disabled', String(previousDisabled));
      previous.tabIndex = previousDisabled ? -1 : 0;
    }
    if (next) {
      next.classList.toggle('slick-disabled', nextDisabled);
      next.setAttribute('aria-disabled', String(nextDisabled));
      next.tabIndex = nextDisabled ? -1 : 0;
    }
    slider.setAttribute('aria-label', 'Product image ' + (currentIndex + 1) + ' of ' + slides.length);
    if (gallery.__updateThumbnailArrows) gallery.__updateThumbnailArrows();
  }

  function setupKeyboardNavigation(gallery, $slider) {
    var slider = $slider[0];
    var hovered = false;
    gallery.addEventListener('pointerenter', function() { hovered = true; });
    gallery.addEventListener('pointerleave', function() { hovered = false; });

    slider.tabIndex = 0;
    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-roledescription', 'carousel');
    slider.setAttribute('aria-label', 'Product images');

    document.addEventListener('keydown', function(event) {
      var target = event.target;
      var activeElement = document.activeElement;
      var focusWithinGallery = gallery.contains(activeElement);
      var pointerWithinGallery = hovered && (activeElement === document.body || !activeElement || focusWithinGallery);
      if (!focusWithinGallery && !pointerWithinGallery) return;
      if (target && (target.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName))) return;
      if (document.querySelector('.pswp--open')) return;

      var current = getCurrentIndex($slider);
      var nextIndex = current;
      if (event.key === 'ArrowLeft') nextIndex -= 1;
      if (event.key === 'ArrowRight') nextIndex += 1;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = getSlides(slider).length - 1;
      if (nextIndex === current) return;

      event.preventDefault();
      event.stopPropagation();
      goTo($slider, nextIndex);
    });
  }

  function setupLazyZoom(gallery, $slider) {
    var buttons = gallery.querySelectorAll('.product-gallery-zoom-trigger');
    if (!buttons.length) return;
    var photoSwipeCallbacks = [];
    var photoSwipeLoading = false;

    function loadPhotoSwipe(source, callback) {
      if (window.PhotoSwipe && window.PhotoSwipeUI_Default) {
        callback();
        return;
      }
      photoSwipeCallbacks.push(callback);
      if (photoSwipeLoading) return;
      photoSwipeLoading = true;

      var script = document.createElement('script');
      script.id = 'product-gallery-photoswipe';
      script.src = source;
      script.onload = function() {
        photoSwipeLoading = false;
        var callbacks = photoSwipeCallbacks.slice();
        photoSwipeCallbacks = [];
        callbacks.forEach(function(queuedCallback) { queuedCallback(); });
      };
      script.onerror = function() {
        photoSwipeLoading = false;
        photoSwipeCallbacks = [];
      };
      document.head.appendChild(script);
    }

    function openPhotoSwipe(button) {
      var open = function() {
        if (!window.PhotoSwipe || !window.PhotoSwipeUI_Default) return;

        var pswpElement = document.querySelectorAll('.pswp')[0];
        if (!pswpElement) return;

        var galleryItems = Array.prototype.map.call(gallery.querySelectorAll('.js-pswp-img'), function(image) {
          return {
            msrc: image.currentSrc || image.src,
            src: image.getAttribute('data-pswp-src'),
            w: parseInt(image.getAttribute('data-pswp-width'), 10),
            h: parseInt(image.getAttribute('data-pswp-height'), 10),
            mediaId: image.getAttribute('data-media-id'),
            el: image
          };
        });
        var imageIndex = Array.prototype.findIndex.call(
          galleryItems,
          function(item) { return item.mediaId === button.getAttribute('data-media-id'); }
        );
        if (imageIndex < 0) imageIndex = parseInt(button.getAttribute('data-image-count'), 10) || 0;
        var options = {
          history: false,
          index: imageIndex,
          closeOnScroll: false,
          getThumbBoundsFn: function() {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var image = galleryItems[imageIndex] && galleryItems[imageIndex].el;
            if (!image) return null;
            var rect = image.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        };
        var pswpGallery = new window.PhotoSwipe(pswpElement, window.PhotoSwipeUI_Default, galleryItems, options);
        pswpGallery.init();
        pswpGallery.listen('close', function() {
          var currentMediaId = this.currItem && this.currItem.mediaId;
          var slideIndex = Array.prototype.findIndex.call(
            getSlides($slider[0]),
            function(slide) { return slide.getAttribute('data-media-id') === currentMediaId; }
          );
          if (slideIndex >= 0) goTo($slider, slideIndex);
        });
      };

      if (window.PhotoSwipe && window.PhotoSwipeUI_Default) {
        open();
      } else {
        loadPhotoSwipe(button.getAttribute('data-photoswipe-src'), open);
      }
    }

    Array.prototype.forEach.call(buttons, function(button) {
      button.setAttribute('aria-controls', 'product-gallery-' + (gallery.getAttribute('data-section-id') || 'main'));
      button.addEventListener('click', function(event) {
        event.preventDefault();
        openPhotoSwipe(button);
      });
    });
  }

  function setupHoverZoom(gallery) {
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    Array.prototype.forEach.call(gallery.querySelectorAll('.product-single__photo__item--image'), function(item) {
      var image = item.querySelector('.product-single__photo__img');
      if (!image || item.getAttribute('data-hover-zoom-ready') === 'true') return;
      item.setAttribute('data-hover-zoom-ready', 'true');

      item.addEventListener('pointerenter', function(event) {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        item.classList.add('is-hover-zoom');
      });
      item.addEventListener('pointermove', function(event) {
        if (!item.classList.contains('is-hover-zoom')) return;
        var rect = item.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        image.style.transformOrigin = Math.max(0, Math.min(100, x)) + '% ' + Math.max(0, Math.min(100, y)) + '%';
      });
      item.addEventListener('pointerleave', function() {
        item.classList.remove('is-hover-zoom');
        image.style.transformOrigin = 'center center';
      });
    });
  }

  function initGallery(gallery) {
    if (gallery.getAttribute('data-gallery-runtime-ready') === 'true') return true;
    $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return false;
    var slider = gallery.querySelector('.js-product-slider');
    if (!slider || !slider.classList.contains('slick-initialized')) return false;

    var $slider = $(slider);
    gallery.setAttribute('data-gallery-runtime-ready', 'true');
    replaceMainArrows(gallery, $slider);
    promoteCustomThumbnails(gallery, $slider);
    hydrateCustomThumbnails(gallery);
    setupThumbnailStrip(gallery, $slider);
    setupKeyboardNavigation(gallery, $slider);
    slider.id = slider.id || 'product-gallery-' + (gallery.getAttribute('data-section-id') || 'main');
    setupLazyZoom(gallery, $slider);
    setupHoverZoom(gallery);

    $slider.off('afterChange.productGalleryRuntime').on('afterChange.productGalleryRuntime', function(event, slick, currentSlide) {
      syncGallery(gallery, currentSlide);
    });
    syncGallery(gallery, getCurrentIndex($slider));
    return true;
  }

  // Wait for Slick to start on this gallery, however long that takes: watch
  // the slider's class for slick-initialized, listen for Slick's init event,
  // and poll as a backstop (Slick can start late, for example in the theme
  // editor, where theme.min.js waits for imagesLoaded first).
  function whenReady(gallery) {
    if (initGallery(gallery) || gallery.__olGalleryWaiting) return;
    gallery.__olGalleryWaiting = true;
    var slider = gallery.querySelector('.js-product-slider');
    var observer = null;
    var timer = null;
    var started = Date.now();

    function attempt() {
      if (!initGallery(gallery)) return false;
      gallery.__olGalleryWaiting = false;
      if (observer) observer.disconnect();
      if (timer) window.clearTimeout(timer);
      return true;
    }

    if (slider && window.MutationObserver) {
      observer = new MutationObserver(attempt);
      observer.observe(slider, { attributes: true, attributeFilter: ['class'] });
    }
    if (slider && window.jQuery) {
      window.jQuery(slider).one('init', function() { window.setTimeout(attempt, 0); });
    }
    (function poll() {
      if (attempt()) return;
      if (Date.now() - started > 30000) {
        gallery.__olGalleryWaiting = false;
        if (observer) observer.disconnect();
        return;
      }
      timer = window.setTimeout(poll, 250);
    })();
  }

  function initAllGalleries() {
    Array.prototype.forEach.call(document.querySelectorAll(gallerySelector), whenReady);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }
  document.addEventListener('shopify:section:load', initAllGalleries);
})(window, document);
